import { PhoneVerificationState } from '../Reducers'
import { PhoneVerificationAction, PhoneVerificationActionType } from './PhoneVerificationActions'

const INITIAL_STATE: PhoneVerificationState = {
	phoneVerificationRequired: false,
	submitPhoneNumberInProgress: false,
	validPhoneNumberSubmitted: false,
	submitVerificationCodeInProgress: false,
	validVerificationCodeSubmitted: false,
	internationalPhoneNumber: {
		countryCode: undefined,
		localNumber: undefined,
	},
	errorMsg: undefined,
	submitPurchase: false,
	status: 'NOT_VERIFIED',
}

export const phoneVerificationReducer = (
	state: PhoneVerificationState = INITIAL_STATE,
	action: PhoneVerificationAction,
): PhoneVerificationState => {
	switch (action.type) {
	case PhoneVerificationActionType.RECEIVED_CUSTOMER_STATUS: {
		return { ...state, phoneVerificationRequired: action.payload.requiresPhoneVerification }
	}
	case PhoneVerificationActionType.SUBMIT_PHONE_NUMBER:
		return { ...state, internationalPhoneNumber: action.payload, submitPhoneNumberInProgress: true }
	case PhoneVerificationActionType.PHONE_NUMBER_SUBMITTED:
		return {
			...state,
			validPhoneNumberSubmitted: true,
			secondsToExpire: action.payload.secondsToExpire,
			submitPhoneNumberInProgress: false,
		}
	case PhoneVerificationActionType.RESET_PHONE_NUMBER: {
		return {
			...state,
			validPhoneNumberSubmitted: false,
			errorMsg: undefined,
			internationalPhoneNumber: {
				countryCode: undefined,
				localNumber: undefined,
			},
			secondsToExpire: undefined,
		}
	}
	case PhoneVerificationActionType.SUBMIT_VERIFICATION_CODE:
		return { ...state, submitVerificationCodeInProgress: true }
	case PhoneVerificationActionType.VERIFICATION_CODE_SUBMITTED:
		return {
			...state,
			validVerificationCodeSubmitted: action.payload.success,
			submitVerificationCodeInProgress: false,
		}
	case PhoneVerificationActionType.RECEIVED_ERROR:
		return {
			...state,
			errorMsg: action.payload,
			submitPhoneNumberInProgress: false,
			submitVerificationCodeInProgress: false,
		}
	case PhoneVerificationActionType.RESET_ERROR:
		return {
			...state,
			errorMsg: undefined,
		}
	case PhoneVerificationActionType.SUBMIT_PURCHASE:
		return {
			...state,
			submitPurchase: true,
		}
	case PhoneVerificationActionType.RESET_PHONE_VERIFICATION_STATE:
		return INITIAL_STATE
	case PhoneVerificationActionType.RECEIVED_PHONE_VERIFICATION_STATUS:
		return {...state, status: action.payload.status}
	default:
		// Assert never is used to ensure that every known phone verification action is handled by the switch-case.
		const assertNever: never = action
		return state
	}
}
